module.exports = __webpack_public_path__ + "assets/icon_pillar_status.2a15ceab.svg";